import { SnackbarWithContext } from 'components/Modals/DefaultSnackbar';
import React from 'react';
import { useAppContext } from 'services/context';

export const CopiedSnackbar = () => {
  const { snackbarCopied, setSnackbarCopied } = useAppContext();

  return (
    <SnackbarWithContext
      open={snackbarCopied}
      setOpen={setSnackbarCopied}
      message="Copied!"
    />
  );
};
